import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import Loader from '../../../common/Loader.js'
import CustomFooter from '../../../common/TableBottom.js'
import Moment from 'react-moment'
class RechargeHistory extends React.Component {
  state = {
    isLoading: false,

    listCountries: [],
    rechargeHistoryList: [],

    country: localStorage.getItem('countryShortName') || 'KWT',
    limit: 10,
    pageNumber: 0,

    totalPages: 0,
    disabled: false,
  }

  componentDidMount() {
    if (this.props.customer_id) {
      this.getRechargeHistory()
    }
  }

  async getRechargeHistory() {
    this.setState({ isLoading: true })

    await axios
      .get(Constant.getAPI() + `/admin/wallet-recharge-history/${this.props.customer_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          // user_id: this.props.customer_id,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          country: this.state.country,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            rechargeHistoryList: res?.data?.data?.history || [],
            walletAmount: res?.data?.data?.walletAmount || 0,
            currency: res?.data?.data?.currency || 'KWD',

            totalPages: res.data?.pagination?.pages,
            disabled: this.state.pageNumber + 1 >= res.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          display: false,
        },
      },
      {
        name: 'order_number',
        label: 'Order Number',
        options: {
          customBodyRender: (data) => {
            return data
          },
        },
      },
      {
        name: 'amount',
        label: 'Amount',
        options: {
          customBodyRender: (data) => {
            return (
              <>
                {data > 0 ? (
                  <span className="text-success font-weight-bold">{data}</span>
                ) : (
                  <span className="text-danger font-weight-bold">{data}</span>
                )}
              </>
            )
          },
        },
      },
      {
        name: 'payment_status',
        label: 'Payment Status',
        options: {
          customBodyRender: (payment_status) => {
            return (
              <div>
                {payment_status === true ? (
                  <span className="badge badge-pill badge-success">Success</span>
                ) : (
                  <span className="badge badge-pill badge-warning">In Progress</span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'createdAt',
        label: 'Transaction Date',
        options: {
          customBodyRender: (data) => {
            return <Moment format="YYYY-MM-DD hh:mm:ss A">{data}</Moment>
          },
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          customBodyRender: (data) => {
            return data
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: false,
      filter: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            count={this.state.limit}
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
            bookingList: [],
          },
          () => {
            this.getRechargeHistory()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            bookingList: [],
          },
          () => {
            this.getRechargeHistory()
          }
        )
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="page-body">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-block">
                <div className="dt-responsive table-responsive">
                  <MUIDataTable
                    title={'Available Balance:- ' + this.state.walletAmount + ' ' + this.state.currency}
                    className="table-responsive"
                    data={this.state.rechargeHistoryList}
                    columns={columns}
                    options={options}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default RechargeHistory
